import React from 'react'
import { DatePicker } from 'antd'

const CustomDatePicker = props => (
  <DatePicker.RangePicker style={{ width: '100%' }} {...props} />
)

export default CustomDatePicker
